import { useAtomValue } from 'jotai'
import { useTar } from '@/modules'
import { Switch } from '@duck/ui'
import { useLocalSettings } from '@/hooks/useLocalSettings'
import { trackWorkspaceSettings } from '@/modules/workspaceSettingsAnalytics'
import { workspaceChallengeAtom } from '@/store/workspaceAtoms'
import { SettingRow } from '../SettingRow'

interface BehaviorPanelProps {
  onChange?: () => void
}

export const BehaviorPanel = ({ onChange }: BehaviorPanelProps) => {
  const { t } = useTar()
  const { getSetting, setSetting } = useLocalSettings()
  const challenge = useAtomValue(workspaceChallengeAtom)

  const autosaveIndicator = getSetting('autosaveIndicator') ?? true
  const confirmTabClose = getSetting('confirmTabClose') ?? false
  const wrapSelectionWithBrackets = getSetting('wrapSelectionWithBrackets') ?? false
  const wrapSelectionWithQuotes = getSetting('wrapSelectionWithQuotes') ?? false

  return (
    <div>
      <div className="mb-1 text-lg font-semibold text-foreground">
        {t('common.settingsBehavior')}
      </div>
      <div className="mb-5 text-xs text-muted-foreground">
        {t('common.settingsAppliedAcrossAllChallenges')}
      </div>

      <SettingRow
        label={t('common.settingsAutosaveIndicator')}
        control={
          <Switch
            checked={autosaveIndicator}
            onCheckedChange={(v) => {
              setSetting('autosaveIndicator', v)
              trackWorkspaceSettings('workspace_settings:behavior:autosave_indicator_toggle', {
                challengeId: challenge?.id,
                enabled: v,
              })
              onChange?.()
            }}
          />
        }
      />
      <SettingRow
        label={t('common.settingsConfirmTabClose')}
        control={
          <Switch
            checked={confirmTabClose}
            onCheckedChange={(v) => {
              setSetting('confirmTabClose', v)
              trackWorkspaceSettings('workspace_settings:behavior:confirm_tab_close_toggle', {
                challengeId: challenge?.id,
                enabled: v,
              })
              onChange?.()
            }}
          />
        }
      />
      <SettingRow
        label={t('common.settingsWrapSelectionWithBrackets')}
        control={
          <Switch
            checked={wrapSelectionWithBrackets}
            onCheckedChange={(v) => {
              setSetting('wrapSelectionWithBrackets', v)
              trackWorkspaceSettings('workspace_settings:behavior:wrap_selection_brackets_toggle', {
                challengeId: challenge?.id,
                enabled: v,
              })
              onChange?.()
            }}
          />
        }
      />
      <SettingRow
        label={t('common.settingsWrapSelectionWithQuotes')}
        control={
          <Switch
            checked={wrapSelectionWithQuotes}
            onCheckedChange={(v) => {
              setSetting('wrapSelectionWithQuotes', v)
              trackWorkspaceSettings('workspace_settings:behavior:wrap_selection_quotes_toggle', {
                challengeId: challenge?.id,
                enabled: v,
              })
              onChange?.()
            }}
          />
        }
      />
    </div>
  )
}
